import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default function initHeadlineSlider(selector = '.ks-headline-slider__swiper') {
  const sliders = document.querySelectorAll(selector);

  sliders.forEach((el) => {
    const root = el.closest('.ks-headline-slider__slider') || el.parentElement;
    const nextEl = root ? root.querySelector('.ks-headline-slider__nav-next') : null;
    const prevEl = root ? root.querySelector('.ks-headline-slider__nav-prev') : null;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1.15,
      spaceBetween: 16,
      navigation: { nextEl, prevEl },
      roundLengths: true,
      watchOverflow: true,
      breakpoints: {
        576: { slidesPerView: 1.5 },
        768: { slidesPerView: 2.2, spaceBetween: 24 },
        1200: { slidesPerView: 2.4, spaceBetween: 24 },
      },
    });
  });
}
